import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";
import { siteActivate } from "./siteActivate";
import { application } from "../application/application";

function init() {
    $("#btnApproveSite").click(function() { setSiteApproval(true); });
    $("#btnStartRejectSite").click(showPopover);
    $(document).on("click", "#btnSubmitRejectSite", function(e) { setSiteApproval(false); });
    $(document).on("click", "#cancelSubmit", hidePopover);
    $("[data-toggle=popover]").popover({
        container: "body",
        trigger: "manual",
        html: true,
        sanitize: false,
        template:
            "<div class=\"popover\" role=\"tooltip\"><div class=\"arrow\"> </div><h3 class=\"popover-header\"></h3><div class=\"popover-body\"></div></div>"
    });
}

function showPopover() {
    $("#divApproveRejectButton").popover("show");
}
function hidePopover() {
    $("#divApproveRejectButton").popover("hide");
}

function setSiteApproval(isApproved) {
    if ($("#hdnHasArea").val() === "false" && isApproved) {
        services.notificationService.error("You need to set an Area before approving a site!");
        return;
    }
    const siteId = $("#hdnSiteId").val();
    const requestPayload = {
        url: "/Sites/" + siteId + "/Approval/", data: { isApproved: isApproved }
    };
    if (!isApproved) {
        const rejectedDecisionExplanation = $("#txtRejectSite").val();
        if (!rejectedDecisionExplanation || rejectedDecisionExplanation.length > 31) {
            $("#divSiteRejectValidationWarning").removeClass("hidden");
            return;
        }
        $("#divSiteRejectValidationWarning").addClass("hidden");
        requestPayload.data.rejectedDecisionExplanation = rejectedDecisionExplanation;
    }
    
    $("#btnSubmitRejectSite").prop("disabled", true);
    
    dataaccess.put(requestPayload).done(function() {
        if (!isApproved) {
            $("#btnSiteApprovalStatus").removeClass("btn-outline-primary").removeClass("btn-outline-success").addClass("btn-outline-danger");
            $("#iSiteApprovalIcon").removeClass("fa-ellipsis-h").removeClass("fa-check-circle").addClass("fa-exclamation-circle");
            $("#divSiteApprovalMessage").text("Rejected");
            $("#btnApproveSite").removeClass("hidden");
            $("#btnStartRejectSite").addClass("hidden");
            siteActivate.setSiteIsActive(isApproved, siteId).done(function() {
                siteActivate.disableActivation();
            });
        } else {
            $("#btnSiteApprovalStatus").removeClass("btn-outline-primary").removeClass("btn-outline-danger").addClass("btn-outline-success");
            $("#iSiteApprovalIcon").removeClass("fa-ellipsis-h").removeClass("fa-exclamation-circle").addClass("fa-check-circle");
            $("#divSiteApprovalMessage").text("Approved");
            $("#btnApproveSite").addClass("hidden");
            $("#btnStartRejectSite").removeClass("hidden");
            siteActivate.setSiteIsActive(isApproved, siteId).done(function() {
                siteActivate.enableActivation();
            });
        }

        $("#btnSubmitRejectSite").prop("disabled", false);
        $("#divSiteDecisionBy").text(new Date().toLocaleDateString() + " | " + $("#hdnUserFullName").val());
        window.location.href = application.baseUrl + "/siteDetails/index/" + $("#hdnSiteId").val();

        hidePopover();
    });
}

export const siteDetailsApproveSite = {
    init: init
};